export const ListQueryKey = 'projectCoinTransConfigs';
export const DetailQueryKey = 'projectCoinTransConfig';
export const Urls = {
  selectUrl: '/coinTransConfig/list',
  updateUrl: '/coinTransConfig/update',
  deleteUrl: '/coinTransConfig/delete',
  createUrl: '/coinTransConfig/create',
  detailUrl: '/coinTransConfig/info'
};